/* Podo-Logic — Borne
   1) Active le mode borne dès qu'on est sur une page « borne » (veille, accueil, sous-menus)
   2) Retourne à l'écran de veille après une période sans toucher */
(function () {
  var DELAI_INACTIVITE = 90 * 1000; // 90 secondes — ajuster au besoin
  var URL_VEILLE = '/pages/borne-veille';

  var script = document.currentScript;
  var estPageBorne = script && script.getAttribute('data-borne-page') === '1';
  var estPageVeille = window.location.pathname.indexOf(URL_VEILLE) === 0;

  function modeBorneActif() {
    try { return localStorage.getItem('plKiosk') === '1'; } catch (e) { return false; }
  }

  // 1) Activation du mode borne (ne dépend plus seulement de la veille)
  if (estPageBorne) {
    try { localStorage.setItem('plKiosk', '1'); } catch (e) {}
    document.documentElement.classList.add('pl-kiosk');
  }

  // 2) Minuterie d'inactivité : seulement en mode borne, jamais sur la veille elle-même
  if (!modeBorneActif() || estPageVeille) return;

  var minuterie;
  function relancer() {
    clearTimeout(minuterie);
    minuterie = setTimeout(function () {
      window.location.href = URL_VEILLE;
    }, DELAI_INACTIVITE);
  }

  ['pointerdown', 'touchstart', 'keydown', 'scroll', 'wheel'].forEach(function (evt) {
    window.addEventListener(evt, relancer, { passive: true, capture: true });
  });

  // Relance aussi quand on revient sur une page avec le bouton Retour
  window.addEventListener('pageshow', relancer);

  relancer();
})();